import cx from 'classnames';
import React from 'react';
import { FormLegend } from './form-legend.js';
export const FormFieldset = ({ children, className, density, error, indentation, layout, legend, legendProps, ...rest }) => (React.createElement("fieldset", { className: cx('tds-form-fieldset', {
        [`tds-density--${density}`]: density,
        [`tds-form-layout--${layout}`]: layout,
        [`tds-form--${indentation}`]: indentation,
        'tds-form--error': error,
    }, className), ...rest },
    legend && React.createElement(FormLegend, { ...legendProps }, legend),
    children));
